import { Box, Link, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const MenuBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '270px',
    maxHeight: '720px',
    /* minHeight: 'calc(100vh - 120px)', */
    backgroundColor: palette.white,
    padding: '24px 0',
    borderRadius: '24px',
    position: 'sticky',
    top: '24px',
  };
});

export const MainMenuBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    paddingBottom: '16px',
    marginBottom: '16px',
    borderBottom: `1px solid ${palette.border.default}`,
  };
});

const ItemLink = styled(Link)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'block',
    color: palette.text.body,
    fontWeight: 400,
    cursor: 'pointer',
    padding: '10px 24px',
    fontSize: '16px',
    lineHeight: '22px',
    textDecoration: 'none',

    '&:hover': {
      backgroundColor: palette.hover.background,
    },
  };
});

export const MenuItemLink = styled(ItemLink)<{ selected?: boolean }>(({ selected }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: selected ? palette.text.header : palette.text.body,
    fontWeight: selected ? 500 : 400,
    cursor: selected ? 'auto' : 'pointer',
    pointerEvents: selected ? 'none' : 'auto',
    borderLeft: '4px solid',
    borderColor: selected ? palette.primary.purple500 : 'transparent',
  };
});

export const MenuExternalItemLink = styled(ItemLink)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
  };
});
